import { render } from "./TheScooterTypeDetails.vue?vue&type=template&id=3f2303ec"
import script from "./TheScooterTypeDetails.vue?vue&type=script&lang=js"
export * from "./TheScooterTypeDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__